import { render, staticRenderFns } from "./NVMessage.vue?vue&type=template&id=61307bba&"
import script from "./NVMessage.vue?vue&type=script&lang=js&"
export * from "./NVMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports